import React, { useState } from 'react';
import styles from './ArticleList.module.scss';
import formStyles from '../../common/ui/Form.module.scss';
import useFetch from '../../common/hooks/useFetch';

import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import qs from 'query-string';

import Article from '../article/Article';

const ArticleList = (props) => {

  const [title, setTitle] = useState('');
  const [path, setPath] = useState('');

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15);

  const location = useLocation();
  const params = qs.parse(location.search);
  const getFetchUrl = () => {
    if (params.boardId) {
      const isParent = props.categoriesDic[params.boardId].childCount > 0;
      params.isParent = isParent;
    }
    return `/api/board/list?${qs.stringify(params)}`;
  }
  const url = getFetchUrl();
  const [fetch, reFetch] = useFetch(url, 400, 100);

  const navigate = useNavigate();
  const isLogin = useSelector((state) => state.profileReducer.isLogin);

  useEffect(() => {
    let temp = props.title;
    if (params.boardId) {
      const board = props.categoriesDic[params.boardId];
      if (board.parentId) {
        temp += ` / ${props.categoriesDic[board.parentId].title}`;
      }
      temp += ` / ${board.title}`;
    }

    setTitle(params.boardId ? props.categoriesDic[params.boardId].title : props.title);
    setPath(temp);
    reFetch();
  }, [location]);


  // Article Op
  ///////////////////////////////////////
  const listArticles = () => {
    let arr = [];

    const articles = fetch.data.articles;
    const totalCount = fetch.data.totalCount;

    if (articles?.length > 0) {
      articles.forEach((x, index) => {
        const articleIndex = totalCount - (page - 1) * limit - index;
        arr.push(<Article key={index} info={
          {
            index: articleIndex,
            rootCategory: params.rootCategory,
            articleId: x.id,
            boardId: x.boardId,
            title: x.title,
            writer: x.writerNickname,
            writeDate: x.writeDate,
            replyCount : x.replyCount,
            viewCount: x.viewCount,
            likeCount: 0
          }
        } />);
      });
    }
    else {
      arr.push(
        <tr key={0}>
          <td colSpan={6} style={{ height: '50px' }}>등록된 게시글이 없습니다.</td>
        </tr>
      );
    }

    return arr;
  }

  const writeArticle = () => {
    params.command = 'write';
    navigate(location.pathname + '?' + qs.stringify(params));
  }

  const listPages = () => {
    const limit = params.limit ? parseInt(params.limit) : 15;
    const currentPage = params.page ? parseInt(params.page) : 1;
    const totalPages = parseInt(Math.ceil(fetch.data.totalCount / limit));
    const bundleCount = parseInt(Math.ceil(totalPages / 15));
    const bundleIndex = parseInt((currentPage - 1) / 15);

    const arr = [];
    if (bundleIndex >= 1) {
      arr.push(<p key={-1} onClick={() => { navigatePage((bundleIndex - 1) * 15 + 1); }}>{'<<'}</p>);
    }
    if (currentPage >= 2) {
      arr.push(<p key={-2} onClick={() => { navigatePage(currentPage - 1) }}>{'<'}</p>);
    }
    for (let i = 0; i < 15; i++) {
      const p = bundleIndex * 15 + i + 1;
      if (p > totalPages) {
        break;
      }
      arr.push(
        <p key={i} className={p === currentPage ? styles.selected : styles.none} onClick={() => { navigatePage(p) }}>
          {p}
        </p>);
    }
    if (currentPage < totalPages) {
      arr.push(<p key={-3} onClick={() => { navigatePage(currentPage + 1) }}>{'>'}</p>);
    }
    if (bundleIndex < bundleCount - 1) {
      arr.push(<p key={-4} onClick={() => { navigatePage((bundleIndex + 1) * 15 + 1) }}>{'>>'}</p>);
    }

    return arr;
  }

  const navigatePage = (page) => {
    const _params = { ...params };
    _params.page = page;
    navigate(location.pathname + '?' + qs.stringify(_params));
  }

  // Render
  ////////////////////////////////////////
  if (fetch.error) {
    return (
      <div id={styles.wrapper_articleList}>
        <div id={styles.error}>
          오류가 발생하였습니다.
        </div>
      </div>
    );
  }

  return (
    <div id={styles.wrapper_articleList}>
      <div id={styles.header}>
        <p className={styles.title}>{title}</p>
        <p className={styles.path}>{path}</p>
      </div>

      {!fetch.isLoading &&
        <div id={styles.body}>
          <div className={styles.search_bar}>
            <select>
              <option>제목</option>
              <option>내용</option>
              <option>작성자</option>
            </select>
            <input type='text'></input>
            <div className={styles.container_img}>
              <div className={styles.search_img} />
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th style={{ width: '10%' }}>글번호</th>
                <th style={{ width: '50%' }}>제목</th>
                <th style={{ width: '15%' }}>작성자</th>
                <th style={{ width: '11%' }}>작성일</th>
                <th style={{ width: '7%' }}>조회수</th>
                <th style={{ width: '7%' }}>좋아요</th>
              </tr>
            </thead>
            <tbody>
              {listArticles()}
            </tbody>
          </table>
        </div>
      }

      {!fetch.isLoading &&
        <div id={styles.footer}>
          <div id={styles.wrapper_page}>
            <div className={styles.page_container}>
              {listPages()}
            </div>
          </div>
          {isLogin && <button className={formStyles.button} type='button' onClick={writeArticle}><p>작성하기</p></button>}
        </div>
      }

    </div>

  )
}

export default ArticleList;